<template>
  <div
    class="html_teamInfor"
    :class="
      datas.statisticsModels && datas.statisticsModels.length > 8
        ? 'scrollBox'
        : ''
    "
    v-if="datas.objectInfo && datas.objectInfo.length == 1"
  >
    <div class="all">
      <div class="teamImg">
        <img :src="teamInfor.teamLogo" />
        <span v-text="_valFormatHandler(teamInfor.teamName)"></span>
      </div>
      <div
        v-for="(item, index) in datas.statisticsModels"
        :key="item.statisticalEn"
        class="info"
        :class="[
          index % 2 === 1 ? 'gray' : '',
          item.statisticalEn === 'worldRank' ? 'worldRank' : '',
        ]"
      >
        <div
          class="info-name"
          v-text="
            item.statisticalEn === 'worldRank'
              ? _valFormatHandler(item.name, '：')
              : _valFormatHandler(item.name)
          "
        ></div>
        <div
          class="info-value"
          v-text="_valFormatHandler(tableData[item.statisticalEn], item.suffix)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
// import datas from './TeamInfo.json'
export default {
  name: 'html_teamInfor',
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    title: {
      type: [String, null],
      default: null,
    },
  },
  data() {
    return {}
  },
  created() {
    console.debug(this.datas)
  },
  computed: {
    teamInfor() {
      return this.datas.objectInfo && this.datas.objectInfo.length > 0
        ? this.datas.objectInfo[0]
        : {
            teamLogo: '',
            teamName: '',
          }
    },
    tableData() {
      return this.datas.data.dataList && this.datas.data.dataList.length > 0
        ? this.datas.data.dataList[0]
        : {}
    },
  },
  methods: {
    _valFormatHandler(val, ceil) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ''
      } else {
        if (val && ceil) {
          data = `${val}${ceil ? ceil : ''}`
        } else {
          data = val
        }
      }
      // console.debug(val, data)
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.clearfix:after {
  content: '.';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
  overflow: hidden;
}
.clearfix {
  zoom: 1;
} /* for IE/Mac */
.html_teamInfor {
  width: 100%;
  padding: 0 0.556vw;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  &.scrollBox {
    margin: 0.972vw 0;
    align-items: flex-start;
    height: calc(100% - 1.944vw);
    overflow: auto;
  }
}

.all {
  width: 80%;
}

.half {
  width: 48%;
  overflow: auto;
  height: 20.83vw;
}
.halfS {
  flex-shrink: 0;
}
.teamImg {
  font-size: 1.11vw;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  display: flex;
  align-items: center;
}

.teamImg img {
  width: 2.083vw;
  height: 2.083vw;
  margin-right: 0.972vw;
  border-radius: 50%;
}

.info {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.833vw;
  font-weight: bold;
  /* color: rgba(51, 51, 51, 1); */
  color: var(--mixtmt_greyColor_main);
  height: 2.065vw;
  padding: 0 0.694vw;
  &.worldRank {
    justify-content: flex-start;
    font-size: 0.972vw;
    height: 1.388vw;
    margin: 0.694vw 0;
  }
}

.info-name {
  text-align: left;
}

.gray {
  background: var(--mixtmt_subColor_main05);
}
</style>
